import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './plugins/view-design'
import './plugins/vue2-google-maps'
import './plugins/vue-card-format'
import './plugins/vue-social-sharing'
import './plugins/vue-youtube'

import './assets/scss/main.scss'

import { getAuthSession } from '@/services/auth'
import { AppMixins } from './utils/appMixins'

Vue.mixin(AppMixins)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next('/404-page-not-found')
  } else {
    if (to.meta.requiredAuth) {
      if (getAuthSession().isAuthenticated) {
        if (to.meta.role === localStorage.getItem('userType')) {
          next()
        } else {
          next({ name: '404-page-not-found' })
        }
      } else {
        next({ name: 'buyer-login' })
      }
    } else {
      next()
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
